module.exports = __webpack_public_path__ + "img/file-preview.f9acfeb5.webp";